import Skeleton from 'components/SA/Skeleton'
import React from 'react'
import styles from './DesktopHeader.module.scss'

const HeaderSearchIconsSkeleton = () => {
  return (
    <>
      <Skeleton width='325px' height='52px' />
      <div className={styles.headerIconsSkeletonContainer}>
        <Skeleton width='35px' height='35px' shape='circle' />
        <Skeleton width='35px' height='35px' shape='circle' />
        <Skeleton width='35px' height='35px' shape='circle' />
        <Skeleton width='35px' height='35px' shape='circle' />
        <Skeleton width='35px' height='35px' shape='circle' />
      </div>
    </>
  )
}

export default HeaderSearchIconsSkeleton
